import { CollectionType, ICollection } from 'types';

export const getTypeText = (type: ICollection['type']) => {
  switch (type) {
    case CollectionType.MAIN_BANNER:
      return '메인배너';
    case CollectionType.SINGLE_BANNER:
      return '띠배너';
    case CollectionType.GRID:
      return '2열 그리드';
    case CollectionType.CARD:
      return '카드';
    default:
      return '기본';
  }
};
